
import { computed, defineComponent, ref, SetupContext, watch } from "vue";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import { DESKTOP_PRICE, DESKTOP_TYPE, MOBILE_PRICE, MOBILE_TYPE, TSD_PRICE, TSD_TYPE } from "@/config/rates";
import { useStore } from "@/store";

export default defineComponent({
  name: "BuyRateModal",
  setup(props, { emit }: SetupContext) {
    const store = useStore();
    const account = computed(() => store.getters.accountGet);
    const selectedRateTypeId = computed(() => store.getters.getSelectedRateTypeId);
    const hasSubscriptions = computed(() => store.getters.hasSubscriptions);
    const ratesData = computed(() => store.getters.rateInfoData.filter((i) => i.type !== selectedRateTypeId.value));

    const onClickBuy = (rate: any) => {
      emit("click-rate");
      store.commit("setSelectedRateTypeId", rate.type);
    };

    return {
      onClickBuy,
      account,
      ratesData,
      hasSubscriptions,
    };
  },
  components: {
    BaseButton,
    BaseModal,
  },
});
